import GoodFlipLogoWhite from '../../../assets/images/logos/goodflip.webp'
import MySaathiLogo from '../../../assets/images/sema-onboarding/mysaathi-logo.webp'
import Text from '../../../components/Text'

const PageFooter = () => {
  return (
    <div className="flex flex-col items-center justify-center space-y-2 justify-self-end">
      <div className="flex items-center justify-center gap-2">
        <img
          src={GoodFlipLogoWhite}
          alt="goodflip-logo"
          className="w-[90px] h-4 object-scale-down"
        />
        <div className="h-5 w-[1px] bg-[#D0D5DD]" />
        <img
          src={MySaathiLogo}
          alt="my-saathi-logo"
          className="w-[90px] h-4 object-scale-down"
        />
      </div>
      <div>
        <Text
          variant="label"
          size="small"
          tag="p"
          textalign="center"
          className="text-[#667085]"
        >
          <b>GoodFlip</b> in partnership with <b>Zydus</b> <br /> Your trusted
          health partner.
        </Text>
      </div>
    </div>
  )
}

export default PageFooter
